<template>
  <div class="onr-body__instructor app-page" v-if="currentInstructor">
    <div class="onr-body__instructor-panel" id="instructor-photo">
      <div class="instructor-header-top">
        <button class="back-btn" type="button" @click="goBack">
          ← Back
        </button>
      </div>
      <div class="onr-body__instructor-image">
        <img class="instructor-panel__img" :src="profileImage"/>
      </div>
      <div class="onr-body__instructor-header">
        <h2 class="onr-body__instructor-heading">{{
            currentInstructor.firstName + " " + currentInstructor.lastName
          }}</h2>
      </div>
      <div class="onr-body__instructor-content">
        <!-- <h3 class="onr-body__instructor-content--title-heading">course title:</h3> -->
        <!--<p class="onr-body__instructor-content--title-text">"{{ currentInstructor.quote }}"</p>-->
        <h4 class="onr-body__instructor-content--about-heading">ABOUT ME</h4>
        <div class="about-grid">
          <!-- ✅ Gender -->
          <div class="about-row">
            <div class="about-label">
              <span class="about-icon">{{ genderIcon(currentInstructor.gender) }}</span> Gender
            </div>
            <div class="about-value">{{ formatGender(currentInstructor.gender) }}</div>
          </div>
          <div class="about-row">
            <div class="about-label"><span class="about-icon">🌍</span> Country</div>
            <div class="about-value">{{ getNameByCode(currentInstructor.country) || "—" }}</div>
          </div>

          <div class="about-row">
            <div class="about-label"><span class="about-icon">📍</span> Residence</div>
            <div class="about-value">
              {{ getNameByCode(currentInstructor.residence) || "—" }}
            </div>
          </div>



          <div class="about-row">
            <div class="about-label"><span class="about-icon">💼</span> Occupation</div>
            <div class="about-value">{{ currentInstructor.occupation || "—" }}</div>
          </div>

          <div class="about-row">
            <div class="about-label"><span class="about-icon">🎯</span> Interests</div>
            <div class="about-value">{{ currentInstructor.interests || "—" }}</div>
          </div>

          <div class="about-row">
            <div class="about-label"><span class="about-icon">🎓</span> Academic Fields</div>
            <div class="about-value">{{ currentInstructor.academicFields || "—" }}</div>
          </div>
        </div>

        <div class="onr-body__instructor-content--keywords">
          <div
              v-for="(keyword, index) in currentInstructor.keywords"
              :key="index"
              class="instructor-keyword"
          >
            {{ keyword.label }}: {{ keyword.count }}
          </div>
        </div>
      </div>
    </div>
    <div class="onr-body__instructor-panel--side">
      <h4 class="onr-body__instructor-details--heading">STUDENT DETAILS</h4>
      <div class="onr-body__instructor-details--content-container">
        <p class="onr-body__instructor-details--content-label">Subject</p>
        <p v-if="currentInstructor.sbs" class="onr-body__instructor-details--content-text">SBS (English)</p>
        <p v-if="currentInstructor.lbl_coding" class="onr-body__instructor-details--content-text">LBL(Coding)</p>
        <p v-if="currentInstructor.lbl_office" class="onr-body__instructor-details--content-text">LBL(MS Office)</p>
        <p v-if="currentInstructor.han" class="onr-body__instructor-details--content-text">Hanbud (Korean)</p>
      </div>
      <div class="onr-body__instructor-details--content-container instructor-details__availability">
        <p class="onr-body__instructor-details--content-label">Availability: </p>

        <div class="onr-body__instructor-details--availability">
          <template
              v-for="(day, index) in days"
              :key="index"
          >
            <a class="onr-body__instructor-details--availability-day" @click="onDaySelected(day)"
               :class="dayAvailabilityClasses(day)">
              <span class="instructor-details__availability-short">{{ day.short }}</span>
            </a>
          </template>
        </div>
        <div v-show="selectedDay" class="instructor-details__availability-time">
          <div class="instructor-details__availability-right">
            <template
                v-for="(availability, index) in getAvailableTimes(currentInstructor.availableTimes)"
                :key="index"
            >
              <button
                  v-if="availability.day === selectedDay?.label"
                  type="button"
                  class="availability--label"
                  :class="timeAvailabilityClasses(availability)"
                  @click="onTimeSelected(availability)"
              >
                <p class="instructor-details__availability-right--label">
                  {{ availability.day }} - {{ availability.time }} ({{ availability.tz }})
                </p>
              </button>
            </template>
          </div>
        </div>
      </div>
      <div class="onr-body__instructor-details--schedule">
        <button class="instructor-details__schedule" @click="scheduleCourse()">Schedule</button>
      </div>
    </div>
  </div>
</template>

<script>
//import instructors from '../../data/instructors.json';
import {auth} from '@/firebase.config';
import {ref} from "vue";
import {useRoute} from "vue-router";
import {getProfileImage} from "@/api/image";
import {createClass, getMyClass} from "@/api/classes";
import {getStudent} from "@/api/students";
import countries from "@/data/countries.json";
import {getUser} from "@/api";
import { watch } from "vue";
import { onAuthStateChanged } from "firebase/auth";
import { DateTime } from "luxon";
function getBrowserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
}

function getTeacherTimezone() {
  return localStorage.getItem("tz") || getBrowserTimezone() || "America/New_York";
}

const WEEKDAY = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
const ORDER = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

function parseAvailabilities(availableTimes) {
  if (Array.isArray(availableTimes)) return availableTimes;

  if (typeof availableTimes === "string") {
    try {
      const v = JSON.parse(availableTimes);
      if (Array.isArray(v)) return v;
    } catch (e) {
      // fallback: "Mon 10:00, Tue 11:00"
      return availableTimes
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
    }
  }
  return [];
}

function nextOccurrenceInZone(weekdayNumber, hour, minute, zone) {
  let dt = DateTime.now().setZone(zone).startOf("day");
  while (dt.weekday !== weekdayNumber) dt = dt.plus({ days: 1 });
  return dt.set({ hour, minute, second: 0, millisecond: 0 });
}

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Instructor',
  props: {
    data: {
      type: String,
    }
  },
  components: {
    // Checkbox,
  },

  setup() {
    const route = useRoute();

    const currentInstructor = ref(null);
    const loading = ref(true);
    const error = ref("");

    const myUid = ref(null);

    // ✅ auth 준비될 때까지 기다림
    onAuthStateChanged(auth, async (user) => {
      myUid.value = user?.uid || null;
    });

    // ✅ route param + myUid 둘 다 준비되면 로딩
    watch(
        [() => route.params.id, () => myUid.value],
        async ([studentId, uid]) => {
          currentInstructor.value = null;
          error.value = "";
          loading.value = true;

          if (!studentId) {
            error.value = "Missing route param id";
            loading.value = false;
            return;
          }
          if (!uid) {
            // 아직 로그인 확정 전이면 그냥 대기
            return;
          }

          try {
            const resp = await getStudent(studentId, uid);

            // ✅ 배열/객체 모두 방어
            currentInstructor.value = Array.isArray(resp) ? (resp[0] ?? null) : (resp ?? null);

            if (!currentInstructor.value) {
              error.value = "Student not found or empty response.";
            }
          } catch (e) {
            console.error(e);
            error.value = "Failed to load student.";
          } finally {
            loading.value = false;
          }
        },
        { immediate: true }
    );

    return { currentInstructor, loading, error };
  },
  data() {
    return {
      selectedDay: null,
      selectedTime: '',
      selectedTeacher: '',
      selectedSlot: null,
      profileImage: '',
      days: [
        {
          label: 'Sun',
          short: 'S',
          value: false,
        },
        {
          label: 'Mon',
          short: 'M',
          value: false,
        },
        {
          label: 'Tue',
          short: 'T',
          value: false,
        },
        {
          label: 'Wed',
          short: 'W',
          value: false,
        },
        {
          label: 'Thu',
          short: 'T',
          value: false,
        },
        {
          label: 'Fri',
          short: 'F',
          value: false,
        },
        {
          label: 'Sat',
          short: 'S',
          value: false,
        },

      ],
    }
  },
  mounted() {
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (!auth.currentUser?.uid) return;

    getProfileImage(auth.currentUser.uid).then((response) => {
      this.profileImage = response || 'https://firebasestorage.googleapis.com/v0/b/...';
    }).catch(console.log);

    // ✅ null 방지
    if (!this.currentInstructor) return;

    this.selectedSubject =
        this.currentInstructor.sbs ? 'SBS' :
            this.currentInstructor.lbl_coding ? 'LBL(Coding)' :
                this.currentInstructor.lbl_office ? 'LBL(MS Office)' :
                    this.currentInstructor.han ? 'Hanbud' : '';
  },
  computed: {
    /*
        instructors() {
          return this.instructor;
        },*/
    /*
    currentInstructor() {
      const currentId = this.$route.params.id;
      console.log('..currentId: ', currentId);

      const currentInstructor = this.instructors.find((instructor) => {
        return instructor.tid.toString() === currentId;
      });
      console.log(this.instructor);
      const currentInstructor = this.instructor;
      console.log('..currentInstructor: ', currentInstructor);
      return currentInstructor;
    },
    currentInstructorPhotoPath() {
      return `.${this.currentInstructor.photo}`;
    },*/
    remappedDays() {
      // const availableDays = this.currentInstructor.availability;

      // const mappedDays = map(availableDays, (availableDay) => {
      // 	return filter(this.days, (day) => {
      // 		if (day.label === availableDay.day) {
      // 			return {
      // 				...day,
      // 				value: true,
      // 			}
      // 		}
      // 	});
      // });
      // console.log('..mappedDays: ', mappedDays);
      return '';
    },
  },
  methods: {
    formatGender(g) {
      const v = String(g ?? "").trim().toLowerCase();
      if (!v) return "—";
      if (["m", "male", "man"].includes(v)) return "Male";
      if (["f", "female", "woman"].includes(v)) return "Female";
      if (["nb", "nonbinary", "non-binary"].includes(v)) return "Non-binary";
      return g; // 이미 'Male' 같은 값이면 그대로
    },
    genderIcon(g) {
      const v = String(g ?? "").trim().toLowerCase();
      if (["m", "male", "man"].includes(v)) return "♂️";
      if (["f", "female", "woman"].includes(v)) return "♀️";
      if (["nb", "nonbinary", "non-binary"].includes(v)) return "⚧️";
      return "👤";
    },
    timeAvailabilityClasses(slot) {
      return this.selectedSlot?.utcISO === slot.utcISO ? "selected-time" : "";
    },
    goBack() {
      // 히스토리가 있으면 뒤로, 없으면 목록으로
      if (window.history.length > 1) this.$router.back();
      else this.$router.push({ name: "FindInstructors" }); // 너 프로젝트 라우트명에 맞게 수정
    },
    getNameByRefCode(code) {
      let country = '';
      if (code.toUpperCase().startsWith("BAGH")) {
        country = "Iraq";
      } else if (code.toUpperCase().startsWith("ERBI")) {
        country = "Iraq";
      } else if (code.toUpperCase().startsWith("BETH")) {
        country = "Bethlehem";
      } else if (code.toUpperCase().startsWith("ESKI")) {
        country = "Eskisehir";
      } else if (code.toUpperCase().startsWith("ISTA")) {
        country = "Istanbul";
      } else if (code.toUpperCase().startsWith("ANTI")) {
        country = "Antioch";
      } else if (code.toUpperCase().startsWith("JORD")) {
        country = "Jordan";
      } else if (code.toUpperCase().startsWith("GTC")) {
        country = "GTC";
      } else if (code.toUpperCase().startsWith("LEBA")) {
        country = "Lebanon";
      } else if (code.toUpperCase().startsWith("IRAQ")) {
        country = "Iraq";
      } else if (code.toUpperCase().startsWith("BRAZ")) {
        country = "Brazil";
      } else if (code.toUpperCase().startsWith("EGYP")) {
        country = "Egypt";
      } else if (code.toUpperCase().startsWith("DOMI")) {
        country = "Dominican Republic";
      } else if (code.toUpperCase().startsWith("MORO")) {
        country = "Morocco";
      } else {
        country = "";
      }
      return country ? country : null;
    },
    getNameByCode(countryCode) {
      const country = countries.find(country => country.code === countryCode);
      return country ? country.name : null;
    },
    getAvailableTimes(availableTimes) {
      const viewerTz = getTeacherTimezone();
      const studentTz = this.currentInstructor?.timezone || "UTC";

      const slots = parseAvailabilities(availableTimes);

      const converted = slots
          .map((slot) => {
            const [dayAbbr, time] = slot.split(" ");
            const weekday = WEEKDAY[dayAbbr];
            if (!weekday || !time) return null;

            const [hh, mm] = time.split(":").map(Number);

            const src = nextOccurrenceInZone(
                weekday,
                Number.isFinite(hh) ? hh : 0,
                Number.isFinite(mm) ? mm : 0,
                studentTz
            );

            const dst = src.setZone(viewerTz);

            return {
              // 표시용(뷰어 TZ 기준)
              day: dst.toFormat("ccc"),
              time: dst.toFormat("h:mm a"),
              tz: dst.offsetNameShort || "Local",

              // ✅ 저장/검증용
              utcISO: src.toUTC().toISO(),      // 예: "2026-02-24T19:00:00.000Z"
              viewerISO: dst.toISO(),           // 예: "2026-02-24T14:00:00.000-05:00"
              viewerTz,
              studentTz,
              raw: slot, // 원본 "Mon 10:00" 같은거 (디버깅용)
            };
          })
          .filter(Boolean);

      converted.sort((a, b) => {
        const d = ORDER.indexOf(a.day) - ORDER.indexOf(b.day);
        if (d !== 0) return d;
        // viewerISO는 완전한 datetime이라 이걸로 정렬하면 정확
        return DateTime.fromISO(a.viewerISO).toMillis() - DateTime.fromISO(b.viewerISO).toMillis();
      });

      return converted;
    },
    scheduleCourse() {
      if (!this.selectedDay) {
        alert("Please select a day.");
        return;
      }
      if (!this.selectedSlot?.utcISO) {
        alert("Please select a time.");
        return;
      }
      if (auth.currentUser.uid === this.currentInstructor.uid) {
        alert("You're not a teacher.");
        return;
      }

      getMyClass("Teacher").then((resp) => {
        if (resp) {
          alert("You already have scheduled a class.");
          return;
        }

        getUser().then((resp) => {
          this.user = resp;

          this.selectedSubject =
              this.currentInstructor.sbs ? "SBS" :
                  this.currentInstructor.lbl_coding ? "LBL(Coding)" :
                      this.currentInstructor.lbl_office ? "LBL(MS Office)" :
                          this.currentInstructor.han ? "Hanbud" : "";

          // ✅ 저장은 UTC ISO
          const scheduleUtcISO = this.selectedSlot.utcISO;

          // (선택) 화면 표시용 문자열도 같이 저장하고 싶으면 백엔드에 별도 필드로 보내도 됨
          // const scheduleDisplay = `${this.selectedSlot.day} ${this.selectedSlot.time} (${this.selectedSlot.tz})`;

          createClass(
              auth.currentUser.uid,
              this.user.firstName + " " + this.user.lastName,
              this.currentInstructor.uid,
              this.currentInstructor.firstName + " " + this.currentInstructor.lastName,
              this.selectedSubject,
              scheduleUtcISO,                 // ✅ 이전: this.selectedDay.label + " " + this.selectedTime
              this.selectedSlot.viewerTz      // ✅ (가능하면 추가 파라미터로 같이 보내자)
          )
              .then(() => {
                alert("Your class is scheduled.");
                this.$router.push({ name: "StudentPage" });
              })
              .catch((error) => console.error("..error: ", error));
        });
      })
          .catch((error) => console.error(error));
    },
    onDaySelected(val) {
      this.selectedDay = val;
      this.selectedTime = "";
      this.selectedSlot = null;
    },
    onTimeSelected(slot) {
      this.selectedSlot = slot;      // ✅ utcISO 포함
      this.selectedTime = slot.time; // 기존 로직 호환 (선택 표시용)
    }
    ,
    dayAvailabilityClasses(eachDay) {
      return this.selectedDay?.label === eachDay.label
          ? `selected selected-availability--${this.selectedDay.short}`
          : '';
    },

  }
}
</script>

<style lang="scss">
@use '../../utils/_tokens.scss' as *;

@media only screen and (max-width: 1000px) {
  .onr-body__instructor {
    flex-direction: column;

    .onr-body__instructor-panel {
      width: 100%;
      margin-bottom: 0;

    }

    .onr-body__instructor-panel--side {
      padding: 30px 0;
      width: 100%;

      margin-left: 0;
      flex-shrink: 0;
    }
  }
}

.onr-body {
  &__instructor {
    background-color: $beige-1;
    display: flex;
    height: 100%;
    justify-content: center;
    margin: 0;
    padding: clamp(24px, 4vw, 48px) var(--gut);

    &-details {
      &--availability {
        display: flex;
        justify-content: center;

        &-day {
          background-color: white;
          border: 1px solid $neutral-2;
          border-radius: 5px;
          color: $grey-1;
          cursor: pointer;
          height: 32px;
          margin-right: 5px;
          width: 30px;

          &.selected {
            background-color: $green-1;
            border: 1px solid $green-1;
            color: white;
          }

          &:hover {
            background-color: $green-1;
            border: 1px solid $green-1;
            color: white;
          }

          .instructor-details__availability {
            &-short {
              font-weight: 500;
              vertical-align: middle;
            }
          }
        }
      }

      &--heading {
        margin: 0 0 30px 0;
      }

      &--schedule {
        margin: 40px;
        display: flex;
        justify-content: center;
        .instructor-details__schedule {
          background-color: $green-1;
          border-radius: 25px;
          border: none;
          color: white;
          cursor: pointer;
          font-size: 20px;
          font-weight: 600;
          padding: 15px 40px;
          width: 100%;
          margin: 0 auto;
          min-width: 200px;
          &:hover {
            background-color: $green-2;
          }
        }
      }

      &--content {
        &-container {
          &.instructor-details__availability {
            display: unset;
          }

          .instructor-details__availability {
            &-time {
              display: flex !important;
            }

            &-left {
              &--label {
                font-size: 18px;
                font-weight: 500;
                margin-left: 24px;
                text-align: left;
              }
            }

            &-right {
              margin: 5px 30px 0 auto !important;
              order: 2;

              .availability--label {
                display: block;

                &:focus {
                  border: solid 1px black;
                  border-radius: 25px;
                  margin-bottom: 0.5rem;
                  outline: none;

                }

                &:hover {
                  border: solid 1px black;
                  border-radius: 25px;
                  margin-bottom: 0.5rem;
                }


              }

              &--label {
                margin: 0 !important;
                padding: 0.3rem 0.7rem;
                font-weight: 500;

              }
            }
          }
        }

        &-label {
          color: $black-1;
          font-size: 14px;
          font-weight: 500;
          margin: 0 0 10px;
          text-transform: uppercase;
        }


        &-text {
          font-size: 22px;
          font-weight: 500;
          margin: 0 0 50px;
          text-transform: uppercase;
        }
      }
    }

    &-header {

    }

    &-content {
      &--title {
        &-heading {
          margin: 0;
        }

        &-text {
          // border-left: 5px solid $green-1;
          // border-right: 5px solid $green-1;
          font-size: 20px;
          font-style: italic;
          margin: auto;
          width: 70%;
        }
      }

      &--about {
        &-heading {
          margin: 50px 0 0 0;
        }

        &-text {
          font-size: 18px;
          margin: 1rem 3rem 7rem;
        }
      }

      &--keywords {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 50px;

        .instructor-keyword {
          background-color: $gold-soft;
          color: $navy-deep;
          border-radius: 999px;
          padding: 5px 15px;
          margin: 3px;
        }
      }
    }

    &-image {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      overflow: hidden;

      .instructor-panel {
        &__img {
          border-radius: 50%;
          height: 15em;
        }
      }
    }

    &-panel, &-panel--side {
      background-color: var(--surface);
      border: 1px solid var(--line);
      border-radius: 20px;
      margin: 50px 0;
      width: 50%;

      &--side {
        padding: 30px;
        margin-left: 20px;
        width: 18%;
      }
    }
    &-panel {
      flex: 0 0 50%;
      min-width: 600px;
    }

    &-panel--side {
      flex: 0 0 18%;
      min-width: 280px;
    }
  }
}
.instructor-header-top {
  padding: 1rem 1.5rem 0;
}

.back-btn {
  background: none;
  border: none;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  padding: 0;
}

.back-btn:hover {
  color: #000;
}
.availability--label.selected-time {
  border: solid 1px black;
  border-radius: 25px;
  margin-bottom: 0.5rem;
}
.availability--label {
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
}

.about-grid {
  margin: 1rem 3rem 2rem;
  display: grid;
  row-gap: 8px;
}

.about-row {
  display: grid;
  grid-template-columns: minmax(140px, 180px) 1fr;
  column-gap: 14px;
  align-items: baseline;
}

.about-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: $grey-1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  line-height: 1.35;
}

.about-icon {
  font-size: 14px;
  line-height: 1;
}

.about-value {
  font-size: 16px;
  font-weight: 400;
  color: $black-1;
  word-break: break-word;

  line-height: 1.35;
}

.about-muted {
  color: $grey-1;
  font-weight: 500;
}

@media only screen and (max-width: 1000px) {
  .about-grid { margin: 1rem 1.5rem 2rem; }
  .about-row { grid-template-columns: 110px 1fr; }
  .about-label { white-space: normal; }
}
</style>
